module.exports = __webpack_public_path__ + "static/media/visitbrussels_3.8e854c6b.jpg";